var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterValvesOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.999,
    height: 42,
    viewBox: "0 0 247.999 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9854",
    "data-name": "Group 9854",
    transform: "translate(28.937 7.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M56.707,12.97H31.55a2.61,2.61,0,0,1,0-5.22H56.707a2.61,2.61,0,0,1,0,5.22Z",
    transform: "translate(-28.94 -7.75)",
    fill: "#00b7ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9855",
    "data-name": "Group 9855",
    transform: "translate(71.223 18.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M93,34.24H73.84a2.61,2.61,0,0,1,0-5.22H93a1.417,1.417,0,0,0,1.41-1.42V18.38H245a2.61,2.61,0,0,1,0,5.22H99.587v4A6.619,6.619,0,0,1,93,34.24Z",
    transform: "translate(-71.23 -18.38)",
    fill: "#6a7084"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856",
    transform: "translate(28.937 29.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M56.707,34.24H31.55a2.61,2.61,0,0,1,0-5.22H56.707a2.61,2.61,0,0,1,0,5.22Z",
    transform: "translate(-28.94 -29.02)",
    fill: "#ff001c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857",
    transform: "translate(71.223 7.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M245.392,23.61H94.408V14.39A1.417,1.417,0,0,0,93,12.97H73.84a2.61,2.61,0,0,1,0-5.22H93a6.617,6.617,0,0,1,6.589,6.63v4H245.392a2.615,2.615,0,0,1,0,5.23Z",
    transform: "translate(-71.23 -7.75)",
    fill: "#6a7084"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861",
    transform: "translate(53.475 21.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858",
    transform: "translate(0.65 1.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M65.149,33.29,54.13,40.77V22.5l11.019,7.49L76.168,22.5V40.77Z",
    transform: "translate(-54.13 -22.5)",
    fill: "#2f323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M75.518,23.73V39.55L69.7,35.6l-4.55-3.09L60.6,35.6,54.78,39.55V23.73L60.6,27.68l4.55,3.09,4.55-3.09,5.819-3.95m1.3-2.46L74.8,22.64l-5.819,3.95-3.83,2.6-3.83-2.6L55.5,22.64l-2.02-1.37V42l2.02-1.37,5.819-3.95,3.83-2.6,3.83,2.6L74.8,40.63,76.818,42V21.27Z",
    transform: "translate(-53.48 -21.27)",
    fill: "#6a7084"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863",
    transform: "translate(0 1.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M22.658,20.94h.01l-.09-.16c-.08-.16-.17-.32-.26-.48L11.969,1.54,1.63,20.28c-.1.17-.19.34-.28.51l-.08.14h.01a11.978,11.978,0,1,0,21.378.01Z",
    transform: "translate(0 -1.54)",
    fill: "#00b7ff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867",
    transform: "translate(53.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864",
    transform: "translate(0.65 1.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M65.149,12.01,54.13,19.5V1.23L65.149,8.71,76.168,1.23V19.5Z",
    transform: "translate(-54.13 -1.23)",
    fill: "#2f323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M75.518,2.45V18.27L69.7,14.32l-4.55-3.09L60.6,14.32,54.78,18.27V2.45L60.6,6.4l4.55,3.09L69.7,6.4l5.819-3.95M76.818,0,74.8,1.37,68.978,5.32l-3.83,2.6-3.83-2.6L55.5,1.37,53.48,0V20.72l2.02-1.37,5.819-3.95,3.83-2.6,3.83,2.6L74.8,19.35l2.02,1.37Z",
    transform: "translate(-53.48)",
    fill: "#6a7084"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterValvesOff);
export default __webpack_public_path__ + "static/media/water_valves_off.8df9773ed322f2fd87fb3fc774fdd76f.svg";
export { ForwardRef as ReactComponent };